import { render, staticRenderFns } from "./new-script.component.vue?vue&type=template&id=18999be4&scoped=true&"
import script from "./new-script.component.vue?vue&type=script&lang=ts&"
export * from "./new-script.component.vue?vue&type=script&lang=ts&"
import style0 from "./new-script.component.vue?vue&type=style&index=0&id=18999be4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18999be4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VChip } from 'vuetify/lib/components/VChip';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VChip,VForm,VIcon,VSpacer})
